import { History, createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory();

export const baseUrl = process.env.WEB_BASE_URL;

const history: History = {
	...browserHistory,

	push: (to, state) => {
		if (typeof to === 'string') {
			browserHistory.push(`${baseUrl}${to}`, state);

			return;
		}

		browserHistory.push(
			{
				...to,
				pathname: `${baseUrl}${to.pathname}`,
			},
			state,
		);
	},

	replace: (to, state) => {
		if (typeof to === 'string') {
			browserHistory.replace(`${baseUrl}${to}`, state);

			return;
		}

		browserHistory.replace(
			{
				...to,
				pathname: `${baseUrl}${to.pathname}`,
			},
			state,
		);
	},

};

export default history;
